import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['destroyInput', 'roleIdInput']

  declare readonly destroyInputTarget: HTMLSelectElement
  declare readonly destroyInputTargets: HTMLSelectElement[]
  declare readonly roleIdInputTarget: HTMLSelectElement
  declare readonly roleIdInputTargets: HTMLSelectElement[]

  removeRole (event: CustomEvent): void {
    const target = event.target as HTMLSelectElement

    if (!target.classList.contains('status-ids-select')) {
      const roleId = event.detail.value

      const roleIdInput = this.roleIdInputTargets.find(input => input.value === roleId)

      if (roleIdInput != null) {
        // Construct the name for the _destroy input by replacing [role_id] with [_destroy]
        const destroyInputName = roleIdInput.name.replace('[role_id]', '[_destroy]')

        // Find the corresponding destroyInput using the constructed name
        const destroyInput = this.destroyInputTargets.find(input => input.name === destroyInputName)

        if (destroyInput != null) {
          destroyInput.value = 'true'
        }

        if (roleIdInput.parentElement != null) {
          roleIdInput.parentElement.remove()
        }
      }
    }
  }

  addRole (event: CustomEvent): void {
    const target = event.target as HTMLSelectElement

    if (target.classList.contains('role-ids-select')) {
      const id = event.detail.value

      const selectedOption = Array.from(target.options).find(option => option.value === id)

      if (selectedOption != null) {
        const roleLabel = selectedOption.textContent // Get the label (text content) of the selected option

        this.dispatch('add-status', { bubbles: true, detail: { id, roleLabel } })
      }
    }
  }
}
